module.exports = {"610627001":"美水街道","610627101":"下寺湾镇","610627102":"道镇","610627103":"石门镇","610627200":"桥镇乡","610627203":"劳山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610627.json
// module id = 2978
// module chunks = 0